// extracted by mini-css-extract-plugin
module.exports = {"continueJourneyQRCode":"ContinueJourneyModal_continueJourneyQRCode__38WPJ","loading":"ContinueJourneyModal_loading__3qHJL"};